import dayjs from 'dayjs';
const expirationDateCompare = (expiration_date) => { 
    const expirationDate = dayjs(expiration_date);
    const currentDate = dayjs();
    return expirationDate.isAfter(currentDate); }
export default expirationDateCompare